export const ima3 = () => {
    const existingScript = document.getElementById('ima3');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'ima3';
            script.src = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load ima3 JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}
export const platform = () => {
    const existingScript = document.getElementById('platform');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'platform';
            script.src = window.settings.layoutUrlBase+'assets/platform.js';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load platform JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}
export const castSDK = () => {
    const existingScript = document.getElementById('castSDK');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'castSDK';
            script.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load castSDK JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}